import React, { useCallback, useEffect, useState } from 'react';
import { Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Box, Typography, Divider, CircularProgress } from '@mui/material'
import { grey } from '@mui/material/colors';
// API
import { History, fetchHistory } from 'api/history';

const HistoryList: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [historyList, setHistoryList] = useState<History[]>([]);

  const loadHistory = useCallback(
    async () => {
      setLoading(true);

      const result: History[] = await fetchHistory();
      setHistoryList(result);

      setLoading(false);
    },
    [],
  );

  useEffect(
    () => { loadHistory(); }, [],
  );


  return (
    loading
      ? (
        <CircularProgress sx={{ m: 3 }} />
      )
      : (
        <Box sx={{ m: 2 }}>
          <Typography variant='h4'>
            更新履歴
          </Typography>
          <Divider sx={{ marginY: 3 }} />
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: grey[300] }}>
                <TableRow>
                  <TableCell sx={{ width: '20%' }}>更新日</TableCell>
                  <TableCell>更新内容</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyList.map((row: History) => (
                  <TableRow
                    key={row.id}
                  >
                    <TableCell>
                      {`${row.date.getFullYear()}/${row.date.getMonth() + 1}/${row.date.getDate()}`}
                    </TableCell>
                    <TableCell>{row.content}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box >
      )
  );
};

export default HistoryList;
